// extracted by mini-css-extract-plugin
export default {"logo":"panel_logo__iSrIP","info":"panel_info__9giLU"};